import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import img1 from "../assets/images/noimage.jpg";
import { MyApi } from "../MyApi";

export default function ToursPackagesAll() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get(
          MyApi.BASE_URL + MyApi.TOUR_PACKAGES,
          { headers: { Authorization: MyApi.SECRET_KEY } }
        );

        if (res.data?.status) {
          setServices(res.data.data || []);
        }
      } catch (error) {
        console.error("Expert services API error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  if (loading) {
    return <p className="text-center py-5">Loading services...</p>;
  }

  return (
    <div className="bg_image experts">
      <Container>
        <div className="servi_bx">
          <div className="heading_a">
            <span>Discover Varanasi Like Never Before</span>
            <h3>Customized Local Tours For Everyone..</h3>
          </div>

          <Row className="g-3">
            {services.length > 0 ? (
              services.map((item, index) => {
                // ✅ VERY IMPORTANT NULL CHECK
                if (!item?.product || !item?.parent_category) {
                  return null; // skip broken record
                }

                const product = item.product;
                const category = item.parent_category;

                return (
                  <Col md={4} xs={6} key={product.id || index}>
                    <div className="custom-figure">
                      <Link
                        to={`/${category.categoryurl}/${product.producturl}`}
                      >
                        <img
                          src={product.image_url || img1}
                          alt={product.productname}
                          className="img-fluid"
                          onError={(e) => (e.target.src = img1)}
                        />
                      </Link>

                      <Link
                        to={`/${category.categoryurl}/${product.producturl}`}
                        className="figcaption"
                      >
                        <h3>{product.productname}</h3>

                        {(Number(product.price) > 0 ||
                          Number(product.net_wt) > 0) && (
                          <Row>
                            {Number(product.price) > 0 && (
                              <Col>₹{product.price}</Col>
                            )}

                            {Number(product.net_wt) > 0 && (
                              <Col>
                                Duration{" "}
                                <strong>
                                  {(() => {
                                    const total = Number(product.net_wt);
                                    const h = Math.floor(total);
                                    const m = Math.round((total - h) * 60);
                                    if (h > 0 && m > 0) return `${h}h ${m}m`;
                                    if (h > 0) return `${h}h`;
                                    return `${m}m`;
                                  })()}
                                </strong>
                              </Col>
                            )}
                          </Row>
                        )}

                        {product.productshortcontent && (
                          <p>{product.productshortcontent}</p>
                        )}
                      </Link>
                    </div>
                  </Col>
                );
              })
            ) : (
              <Col>
                <p className="text-center">No services found</p>
              </Col>
            )}
          </Row>

          <div className="text-center mt-5">
            <Link to="/tours" className="button_style">
              <span>Discover More</span>
            </Link>
          </div>
        </div>
      </Container>
    </div>
  );
}
